import {State} from '../../../types/state';
import {NameSpace} from '../../root-reducer';
import { IManagersState } from '../manager';
import { ICompaniesState } from '../../companies/companies';

export const getManagers = (state: State): IManagersState[] | null | undefined => state[NameSpace.Managers].managers;
export const getCompanyForManager = (state: State): ICompaniesState[] | null | undefined => state[NameSpace.Managers].companyForManager;
export const getSearchValueManager = (state: State): string => state[NameSpace.Managers].searchValueName;
export const getSearchValueManagerByCompany = (state: State): string => state[NameSpace.Managers].searchManagerByCompany;
export const getManagerSortBy = (state: State): string => state[NameSpace.Managers].sortBy;